import Vue from 'vue';

export default new Vue({
  data() {
    return {
      innerTenant: null,
    };
  },
  watch: {
    innerTenant(to) {
      if (to == null) {
        localStorage.removeItem('tenant');
        console.log('remove');
      } else {
        localStorage.setItem('tenant', to);
        console.log('add');
      }
    },
  },
  computed: {
    tenant() {
      return this.innerTenant;
    },
  },
  created() {
    this.innerTenant = localStorage.getItem('tenant');
  },
  methods: {
    setTenant(tenant) {
      this.innerTenant = tenant;
    },
    clear() {
      this.innerTenant = null;
    },
  },
});
